<template>
  <div class="dialog">
    <div class="content">
      <div class="close" @click="onClose"></div>
      <div class="title">{{title}}</div>
      <div class="main">
        <slot name="main"></slot>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    title: {
      type: String,
      default: '修改密码',
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 10px;
  transform: translate(-50%, -50%);
  border-radius: 24px;
  z-index: 99;
  .content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    width: 100%;
    height: 100%;
    background: red;
    border-radius: 24px;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 4vh;
      height: 4vh;
      z-index: 2;
      background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e4f688b8d4e34ef78964f2cef65f5138.png') no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .title {
      color: #fff;
      padding: 2vh 2.4vh;
      font-size: 2.5vh;
    }
    .main {
      flex: 1;
      padding: 2vh;
      border-radius: 24px;
      overflow: hidden;
      background-color: #fff;
    }
  }
}
</style>
